module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM15.688 19.324l-3.922 3.922 2 2.002c.416.416.276.752-.312.752h-6.39A1.064 1.064 0 0 1 6 24.936v-6.39c0-.59.336-.728.754-.312l2 2 3.922-3.922a1.065 1.065 0 0 1 1.506 0l1.506 1.506c.416.416.416 1.09 0 1.506zM26 13.454c0 .59-.336.728-.754.312l-2-2-3.922 3.922a1.065 1.065 0 0 1-1.506 0l-1.506-1.506a1.065 1.065 0 0 1 0-1.506l3.922-3.922-2-2.002c-.416-.416-.276-.752.312-.752h6.388C25.524 6 26 6.476 26 7.064v6.39z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/maximize-2.js
// module id = 1263
// module chunks = 14